import Vue from 'vue'
import vuex from 'vuex'
import common from './common'
Vue.use(vuex)
export default new vuex.Store({
  modules: {
    common          // 公共
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js